<!--Report analysis-->
<div class="modal fade rtl " id="exampleModalreportArea" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">بازه مد نظر خود را انتخاب کنید</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-around flex-wrap ">


                <div class="col-5 mb-2">
                    <label class="mb-2">از تاریخ* </label>
                    <form [formGroup]="formFrom">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>

                </div>
                <div class="col-5 mb-2">
                    <label class="mb-2"> تا تاریخ *</label>
                    <form [formGroup]="formTo">
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false"
                            [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">
                            <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                        </ng-persian-datepicker>
                    </form>

                </div>

                <div class=" col-5">
                    <label class="mb-2"> از ساعت *</label>
                    <div class="input-group clockpicker">
                        <input type="text" class="form-control shadow bg-light" value="00:00" id="clocks" readonly>
                        <span class="input-group-addon ">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>


                </div>
                <div class=" col-5">
                    <label class="mb-2"> تا ساعت *</label>
                    <div class="input-group clockpicker">
                        <input type="text" class="form-control shadow bg-light" value="23:59" id="clocke" readonly>
                        <span class="input-group-addon">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>

                </div>



            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-success" id="reporetArea">تایید <i
                        class="fa fa-angle-double-down"></i> </button>

                <button type="button" class="btn btn-primary " data-bs-dismiss="modal">بستن <i
                        class="fa fa-close"></i></button>
            </div>
        </div>
    </div>
</div>
